import { observer } from 'mobx-react';
import React, { useState } from 'react';
import Map, { Layer, Source } from 'react-map-gl';
import { useMapState } from '../../hooks/useMapState';
import PreviewButton, { monoStyle } from './PreviewButton';

const PropertyMap = (props) => {
  const [mapStyle, setMapStyle] = useState(monoStyle);
  const boundry = props.property.boundry;
  const [[viewport, setViewport], mapRefWrapper] = useMapState(boundry);

  const layer = {
    id: 'polygon',
    type: 'fill',
    paint: {
      'fill-color': '#6C757D',
      'fill-opacity': 0.5
    }
  };

  return (
    <Map
      initialViewState={viewport}
      ref={mapRefWrapper}
      mapStyle={`mapbox://styles/hortplus/${mapStyle}`}
      onViewportChange={(next) => setViewport(next)}
      scrollZoom={false}
      dragPan={false}
      dragRotate={false}
      touchPitch={false}
      keyboard={false}
    >
      {boundry && (
        <Source id='boundry' type='geojson' data={boundry}>
          <Layer {...layer} />
        </Source>
      )}
      <PreviewButton
        setMapStyle={setMapStyle}
        mapStyle={mapStyle}
        viewport={viewport}
      />
    </Map>
  );
};

export default observer(PropertyMap);
